(ns minorodata.components.privacy-policy.core
  (:require [clojure.string]
            [reitit.frontend.easy :as rt.easy]
            [re-posh.core :as re-posh]))

(defn privacy-policy []
  (let [dark-mode? @(re-posh/subscribe [:app/prop :app/dark-mode?])]
    [:div {:class "overflow-y-auto h-screen pb-10"}

     [:div {:class "prose mx-auto"}
      [:a {:href    (rt.easy/href :home)
           :data-cy :home-section}
       [:img {:src (if dark-mode?
                     "/img/branding/logo-large-2022.svg"
                     "/img/branding/logo-large-light-2022.svg")
              :title "kleene.ai"
              :class "w-[250px] h-[250px] bg-cover"}]]]

     [:div {:class "mb-5 prose mx-auto"}
      [:h2 "PRIVACY POLICY"]]

     [:div {:class "prose mx-auto"}
      [:h3 "Who are we"]
      [:p "We are MINORO LTD. trading as "
       [:span "kleene.ai "]
       "and can be contacted on the below contact details:"]
      [:p
       [:strong "Email:"] " contact@kleene.ai"]
      [:p
       [:strong "Address:"]" New Broad Street House, 35 New Broad St, London EC2M 1NH"]
      [:h3
       "Why do we collect, store, process, transfer and use your data"]
      [:ol
       [:li "We use your personal information that you voluntarily supply to us in order for us to provide you with information about and access to our products/services."]
       [:li "Minoro Ltd is the data controller (under GDPR) of the personal information we hold about you."]
       [:li "Before accessing or using our Service, please ensure that you have read and understood how we use your data as described in this privacy policy."]]
      [:h3
       [:strong "What happens if I do not provide my personal information"]]
      [:p "We need your personal information in order to provide you information about and access to our products/services. If we do not collect your personal information we will not be able to provide our services to you."]
      [:h3
       [:strong "How we protect your information"]]
      [:p "Your PII data is securely password protected and securely held on a server. Our website server is protected and regularly scanned for malware and viruses. We do not store any credit/debit card details."]
      [:h3
       [:strong "Who will we share your personal information with"]]
      [:p "We will not pass your personal information onto any third parties."]
      [:h3
       [:strong "Transferring your personal information outside Europe"]]
      [:p "We will not share your personal information with organisations based outside Europe."]
      [:h3
       [:strong "How long will we store your personal information"]]
      [:p "We will store your personal information for up to one month if you do not decide to proceed with our services and do not opt-in to receive marketing information from us. If you do become a customer/client of ours, we will store your data for up to one year from the date of the latest purchase of our services. If you do choose to opt into our marketing, we will continue to contact you via email until you opt out. All of our emails contain an unsubscribe link."]
      [:h3
       [:strong "What are your rights in relation to your personal information"]]
      [:p
       [:strong "Right to access"]]
      [:p "You have the right to request copies of the personal information we hold about you at any time."]
      [:p
       [:strong "Right to rectification"]]
      [:p "You have the right to request that we correct any inaccurate personal information we hold about you."]
      [:p
       [:strong "Right to erasure"]]
      [:p "You have the right to request that we delete your personal information from our records."]
      [:p "Please note that we will not be able to delete your personal information whilst we are still providing our services to you. We will be able to delete your personal information once you cancel the service or once the service is completed."]
      [:p
       [:strong "Right to restrict processing"]]
      [:p "You have the right to request that we restrict how we use your personal information."]
      [:p
       [:strong "Right to object"]]
      [:p "You have the right to object to the collection and use of your personal information at any time."]
      [:p
       [:strong "Right to data portability"]]
      [:p "You have the right to obtain a copy of your personal information in a legible and compatible format such as Excel or Word."]
      [:p
       [:strong "Right to withdraw consent"]]
      [:p "You have the right to withdraw your consent for us to use your personal information to send marketing information to you. Each marketing email that we send you will include a link which you can follow to opt-out of future marketing."]
      [:h3
       [:strong "How can I exercise my rights in relation to my personal information"]]
      [:p "You can exercise all of your rights by contacting us on any of the above contact details."]
      [:h3
       [:strong "How do I lodge a complaint about the use of my personal information"]]
      [:p "You can lodge a complaint with us directly by contacting us on one of the above contact details."]
      [:p "You also have the right to lodge a complaint directly with the Information Commissioner’s Office (ICO). The ICO are the regulator who makes sure that we use your personal information in a lawful way."]
      [:p "You can lodge a complaint with the ICO by following this link https://ico.org.uk/concerns/ or calling the ICO on 0303 123 1113."]
      [:h3
       [:strong "Do we use ‘cookies’?"]]
      [:p "Yes. Cookies are small files that a site or its service provider transfers to your computer’s hard drive through your Web browser (if you allow) that enables the site’s or service provider’s systems to recognize your browser and capture and remember certain information. For instance, we use cookies to help us remember and process the items in your shopping cart. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future."]
      [:h3
       [:strong "We use cookies to:"]]
      [:ol
       [:li "Save your browsing analytical data of our website. Via Google analytics."]
       [:li "Save your browsing analytical data of our application. Via Pendo."]]
      [:p "You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since each browser is a little different, look at your browser’s Help Menu to learn the correct way to modify your cookies."]
      [:p "If you turn cookies off, some features will be disabled. It may also affect the performance of the site/app and some features may not function properly."]
      [:h3
       [:strong "Information Collection and Use in the App:"]]
      [:p "For a better experience, and in order to provide our Service, we may require you to provide us, either directly or indirectly, with certain personally identifiable information, including but not limited to user name, and Oauth2 credentials. The information that we request in order to connect to the services will be retained by us and used as described in this privacy policy."]
      [:p "The app uses third party services that may collect information used to identify you. Links to privacy policies of third party service providers used by kleene:"]
      [:p
       [:a {:href "https://policies.google.com/privacy"
                 :target :_blank}
        "Google OAuth"]]
      [:p
       [:a {:href "https://policies.google.com/privacy"
                 :target :_blank}
        "Google Adwords"]]
      [:p
       [:a {:href "https://www.facebook.com/policy.php"
                 :target :_blank}
        "Facebook OAuth"]]
      [:p
       [:a {:href "https://www.facebook.com/policy.php"
                 :target :_blank}
        "Facebook Ads"]]
      [:p "All client data returned by the extract services within the app will be stored in the file store and warehouse specified by the client and will not be retained by kleene."]
      [:h3
       [:strong "Other Service Providers:"]]
      [:p "We may internally employ other third-party services, companies or individuals due to the following reasons:"]
      [:ul
       [:li "To facilitate our Service;"]
       [:li "To provide the Service on our behalf;"]
       [:li "To perform Service-related services; or"]
       [:li "To assist us in analyzing how our Service is used."]]
      [:p "We want to inform users of our Service that these third parties may have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose."]
      [:h3
       [:strong "Log Data:"]]
      [:p "We want to inform you that whenever you use kleene, in a case of an error (and sometimes in normal operation) in the app we collect data and information in our servers called Log Data. This Log Data may include information such as your application user id, the time and date of your use of kleene, and other statistics."]]]))
